import React, {
  ComponentProps,
  useEffect,
  useState,
} from 'react';
import Input from 'pages/Dashboard/components/Input';
import useDebounce from 'pages/Dashboard/hooks/useDebounce';

type Props = Omit<ComponentProps<typeof Input>, 'value' | 'onChange'> & {
  value: string;
  onChange: (value: string) => void;
  delay?: number;
};

export default function SearchInput({
  value,
  onChange,
  delay = 800,
  ...inputProps
}: Props) {
  const [inputValue, setInputValue] = useState<string>(value);
  const debouncedValue = useDebounce<string>(inputValue, delay);

  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue]);

  // Follow value changes made outside this input (tab resets, back/forward)
  useEffect(() => {
    if (value !== debouncedValue) {
      setInputValue(value);
    }
  }, [value]);

  return (
    <Input
      {...inputProps}
      value={inputValue}
      onChange={(nextValue) => {
        setInputValue(nextValue);
      }}
    />
  );
}
